/*********************** Custom JS for Boost AI Search & Discovery  ************************/
FilterOptionItem.prototype.afterBindEvents = function() {
    // Keep the filter tree open after selection
    var originalClick = this.onClick;
    this.onClick = function(event) {
        originalClick.call(this, event);
        // Don't trigger mobile button close behavior
        event.stopPropagation();
    };
};
